module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./node_modules/postcss-loader/lib??embedded!./src/assets/plugins/perfect-scrollbar/css/perfect-scrollbar.css
// module id = ./node_modules/raw-loader/index.js!./node_modules/postcss-loader/lib/index.js??embedded!./src/assets/plugins/perfect-scrollbar/css/perfect-scrollbar.css
// module chunks = styles